export default "assets/images/icons/marker-a4a8f61b.svg";